document.addEventListener('DOMContentLoaded', () => {
  const imageOpeners = document.querySelectorAll('.product__modal-opener--image[data-modal^="#ProductModal-"]');

  imageOpeners.forEach((opener) => {
    if (opener.dataset.imageLightboxBound === 'true') return;
    opener.dataset.imageLightboxBound = 'true';

    const trigger = opener.querySelector('.product__media-toggle');
    const media = opener.querySelector('.product__media');

    if (!trigger || !media) return;

    media.style.cursor = 'zoom-in';

    media.addEventListener('click', (event) => {
      if (event.target.closest('button, a, model-viewer, video, iframe')) return;
      trigger.click();
    });
  });

  const modal = document.querySelector('product-modal.product-media-modal');
  if (!modal || modal.dataset.pinchZoomBound === 'true') return;
  modal.dataset.pinchZoomBound = 'true';

  let activeImage = null;
  let startDistance = 0;
  let startScale = 1;
  let scale = 1;
  let translateX = 0;
  let translateY = 0;
  let startX = 0;
  let startY = 0;
  let lastTap = 0;

  const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

  const getDistance = (touches) => {
    const dx = touches[0].clientX - touches[1].clientX;
    const dy = touches[0].clientY - touches[1].clientY;
    return Math.hypot(dx, dy);
  };

  const getModalImage = (target) => target.closest('.product-media-modal__content img');

  const applyTransform = () => {
    if (!activeImage) return;

    activeImage.style.transform = `translate3d(${translateX}px, ${translateY}px, 0) scale(${scale})`;
    activeImage.style.transformOrigin = 'center center';
    activeImage.style.cursor = scale > 1 ? 'grab' : 'zoom-in';
    activeImage.style.touchAction = scale > 1 ? 'none' : 'pan-y';
  };

  const resetZoom = () => {
    if (!activeImage) return;

    scale = 1;
    translateX = 0;
    translateY = 0;
    applyTransform();
  };

  const setActiveImage = (image) => {
    if (activeImage && activeImage !== image) {
      activeImage.style.transform = '';
      activeImage.style.cursor = '';
      activeImage.style.touchAction = '';
    }

    activeImage = image;
    if (activeImage) {
      activeImage.style.transition = 'transform 160ms ease';
      activeImage.style.willChange = 'transform';
      activeImage.style.cursor = 'zoom-in';
      activeImage.style.touchAction = 'pan-y';
    }
  };

  modal.addEventListener('click', (event) => {
    const image = getModalImage(event.target);
    if (!image) return;

    const now = Date.now();
    setActiveImage(image);

    if (now - lastTap < 300) {
      scale = scale > 1 ? 1 : 2;
      translateX = 0;
      translateY = 0;
      applyTransform();
      event.preventDefault();
    }

    lastTap = now;
  });

  modal.addEventListener('touchstart', (event) => {
    const image = getModalImage(event.target);
    if (!image) return;

    setActiveImage(image);
    activeImage.style.transition = 'none';

    if (event.touches.length === 2) {
      startDistance = getDistance(event.touches);
      startScale = scale;
      event.preventDefault();
    } else if (event.touches.length === 1 && scale > 1) {
      startX = event.touches[0].clientX - translateX;
      startY = event.touches[0].clientY - translateY;
      event.preventDefault();
    }
  }, { passive: false });

  modal.addEventListener('touchmove', (event) => {
    if (!activeImage) return;

    if (event.touches.length === 2) {
      scale = clamp(startScale * (getDistance(event.touches) / startDistance), 1, 4);
      applyTransform();
      event.preventDefault();
      return;
    }

    if (event.touches.length === 1 && scale > 1) {
      translateX = event.touches[0].clientX - startX;
      translateY = event.touches[0].clientY - startY;
      applyTransform();
      event.preventDefault();
    }
  }, { passive: false });

  modal.addEventListener('touchend', () => {
    if (!activeImage) return;

    activeImage.style.transition = 'transform 160ms ease';
    if (scale <= 1.03) resetZoom();
  });

  modal.addEventListener('wheel', (event) => {
    const image = getModalImage(event.target);
    if (!image) return;

    setActiveImage(image);
    scale = clamp(scale + (event.deltaY < 0 ? 0.2 : -0.2), 1, 4);
    if (scale === 1) {
      translateX = 0;
      translateY = 0;
    }
    applyTransform();
    event.preventDefault();
  }, { passive: false });

  modal.querySelector('.product-media-modal__toggle')?.addEventListener('click', resetZoom);
});
